import { kantone } from "@/helpers/tools";
import { Kanton, KantonCollection } from "@/models/Kanton";
import { createModel } from "@kp/js-model";

const collection = new KantonCollection()
export async function useKanton() {
    let models = collection.getModels();
    if (models.length === 0) {
        kantone.forEach((k) => collection.push(createModel(Kanton, k)))
        models = collection.getModels()
    }
    return models
}

export async function useKantonByKuerzel(kuerzel: string): Promise<Kanton | null> {
    let models = collection.getModels();
    if (models.length === 0) {
        kantone.forEach((k) => collection.push(createModel(Kanton, k)))
        models = collection.getModels()
    }
    const res = models.find(m => m.kuerzel === kuerzel.toLowerCase())
    return res || null
}